var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIto02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M504.5,376.667V411.5c0,8.837-7.163,16-16,16h-465c-8.837,0-16-7.163-16-16v-304c0-8.837,7.163-16,16-16h86.611"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M400.111,91.5H488.5c8.837,0,16,7.163,16,16v233.833"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M400.111,121.5h70.685c2.045,0,3.704,1.658,3.704,3.704v234.593c0,2.045-1.658,3.704-3.704,3.704H41.204 c-2.045,0-3.704-1.658-3.704-3.704V125.204c0-2.045,1.658-3.704,3.704-3.704h69.574"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M363.238,504.5H148.762c-3.182,0-5.762-2.58-5.762-5.762V489.5c0-8.284,6.716-15,15-15h196c8.284,0,15,6.716,15,15v9.238 C369,501.92,366.42,504.5,363.238,504.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 427.5,
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 184,
    height: 47
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M107.137,427.5h-30v-21c0-8.284,6.716-15,15-15h0c8.284,0,15,6.716,15,15V427.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 384.66,
    y1: 396.081,
    x2: 398.055,
    y2: 396.081
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 424.846,
    y1: 396.081,
    x2: 438.241,
    y2: 396.081
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 368.228,
    y1: 301.5,
    x2: 408.768,
    y2: 301.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 368.228,
    y1: 327.722,
    x2: 427.772,
    y2: 327.722
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M169.5,363.5h-128c-2.209,0-4-1.791-4-4v-52c0-2.209,1.791-4,4-4h128c2.209,0,4,1.791,4,4v52 C173.5,361.709,171.709,363.5,169.5,363.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M201.122,7.5h174.474C387.97,7.5,398,17.547,398,29.94v205.091c0,12.383-10.022,22.421-22.384,22.421h-83.071 c-5.211,0-11.406,3.808-13.765,8.463l-15.891,31.349c-2.863,5.647-10.915,5.647-13.778,0l-15.894-31.35 c-2.36-4.654-8.554-8.462-13.765-8.462h-83.048c-12.373,0-22.403-10.047-22.403-22.44V29.921C114,17.538,124.022,7.5,136.384,7.5 h31.282"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M295.895,117.172c0.034,11.553-4.845,21.971-12.665,29.275c-5.629,5.258-8.847,12.598-8.847,20.301v11.167h-36.766v-10.848 c0-7.751-3.073-15.261-8.754-20.533c-7.848-7.284-12.758-17.692-12.758-29.244c0-22.036,17.859-39.895,39.895-39.895 C278.141,77.395,295.831,95.03,295.895,117.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M281.032,181.5v13.95c0,9.325-7.559,16.884-16.884,16.884h-16.297c-9.325,0-16.884-7.559-16.884-16.884V181.5 c0-1.98,1.605-3.585,3.585-3.585h42.894C279.427,177.915,281.032,179.52,281.032,181.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 256,
    y1: 42.003,
    x2: 256,
    y2: 50.003
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 219,
    y1: 51.917,
    x2: 223,
    y2: 58.845
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 191.914,
    y1: 79.003,
    x2: 198.842,
    y2: 83.003
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 313.158,
    y1: 149.003,
    x2: 320.086,
    y2: 153.003
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 182,
    y1: 116.003,
    x2: 190,
    y2: 116.003
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 322,
    y1: 116.003,
    x2: 330,
    y2: 116.003
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 191.914,
    y1: 153.003,
    x2: 198.842,
    y2: 149.003
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 313.158,
    y1: 83.003,
    x2: 320.086,
    y2: 79.003
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 289,
    y1: 58.845,
    x2: 293,
    y2: 51.917
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIto02);
export default __webpack_public_path__ + "static/media/ito-02.45da4a3ef1ff53aa7933742b4822224c.svg";
export { ForwardRef as ReactComponent };